export default __webpack_public_path__ + "static/media/in.cff32246.png";